<div class="search-input d-flex align-items-center gap-2">
    <svg-icon src="assets/icons/search.svg" class="search-icon" />
    @if (!control())
    {
        <input [placeholder]="'GENERAL.INPUT_FIELDS.SEARCH' | translate" class="nunito-semibold" (keyup)="filterData()" [(ngModel)]="filter">
    }
    @else 
    {
        <input matInput [formControl]="control()" [placeholder]="'GENERAL.INPUT_FIELDS.SEARCH' | translate" class="nunito-semibold">
    }
</div>
